import { SessionProvider } from "@/providers/SessionProvider";
import { VelProvider } from "@/providers/VelProvider";
import { Outlet, RootRoute } from "@tanstack/react-router";
import { Toaster } from "@/components/ui/toaster";

export default function RootLayout() {
  return (
    <SessionProvider>
      <VelProvider>
        <Outlet />
        <Toaster />
      </VelProvider>
    </SessionProvider>
  );
}

// ✅ Fix: Export a `Route` instance for the root route
export const Route = new RootRoute({
  component: RootLayout,
});
